import axios from 'axios'
import * as XLSX from 'xlsx'

import { REDUX_CONST } from '../../constants'
import { logout } from '../userActions'
import { CONST_ERRORS } from '../../../constants/general'
import { CONST_API } from '../../../constants/api'
import { CONST_GOOGLE_SHEET_IDS } from '../../../constants'

export const resetAppItem = (key) => async (dispatch) => {
	switch (key) {
		case 'createJobSiteVisit':
			dispatch({ type: REDUX_CONST.appConstants.createJobSiteVisit.reset })

			break
		case 'createCustomerMessage':
			console.log('resetting create message')
			dispatch({ type: REDUX_CONST.appConstants.createCustomerMessage.reset })

			break

		default:
			break
	}
}
export const getAvailableEstimators =
	({ jobId, zip, roofType, serviceType, customerDate }) =>
	async (dispatch, getState) => {
		// console.log('Events:Request:GetEvents')
		try {
			dispatch({
				type: REDUX_CONST.appConstants.getAvailableEstimators.request,
			})

			const {
				userLogin: { userInfo },
			} = getState()

			const config = {
				headers: {
					Authorization: `Bearer ${userInfo.token}`,
					'Content-Type': 'application/json',
				},
			}

			// Prepare the body for the POST request
			const requestBody = {
				jobId,
				zip,
				roofType,
				serviceType,
				customerDate,
			}
			console.log(requestBody)

			const { data } = await axios.post(
				CONST_API.channels.apps + CONST_API.routes.getAvailableEstimators,
				requestBody,
				config,
			)

			dispatch({
				type: REDUX_CONST.appConstants.getAvailableEstimators.success,
				payload: data,
			})
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			if (message === CONST_ERRORS['401ExpiredToken']) {
				dispatch(logout())
			}
			dispatch({
				type: REDUX_CONST.appConstants.getAvailableEstimators.fail,
				payload: message,
			})
		}
	}
export const getWeeklyProductionReport = () => async (dispatch, getState) => {
	// console.log('Events:Request:GetEvents')
	try {
		dispatch({
			type: REDUX_CONST.appConstants.getWeeklyProductionReport.request,
		})

		const {
			userLogin: { userInfo },
		} = getState()

		const config = {
			headers: {
				Authorization: `Bearer ${userInfo.token}`,
				'Content-Type': 'application/json',
			},
		}

		// Prepare the body for the POST request
		const requestBody = {}
		console.log(requestBody)

		const { data } = await axios.post(
			CONST_API.channels.apps + CONST_API.routes.getWeeklyProductionReport,
			requestBody,
			config,
		)

		dispatch({
			type: REDUX_CONST.appConstants.getWeeklyProductionReport.success,
			payload: data,
		})
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message
		if (message === CONST_ERRORS['401ExpiredToken']) {
			dispatch(logout())
		}
		dispatch({
			type: REDUX_CONST.appConstants.getWeeklyProductionReport.fail,
			payload: message,
		})
	}
}

export const getDeferredRevenueActions = () => async (dispatch, getState) => {
	// console.log('Events:Request:GetEvents')
	try {
		dispatch({
			type: REDUX_CONST.appConstants.getDeferredRevenueActions.request,
		})

		const {
			userLogin: { userInfo },
		} = getState()

		const config = {
			headers: {
				Authorization: `Bearer ${userInfo.token}`,
				'Content-Type': 'application/json',
			},
		}

		// Prepare the body for the POST request
		const requestBody = {
			returnType: 'BUSINESS_MANAGER_DR_ACTIONS',
		}
		console.log(requestBody)

		const { data } = await axios.post(
			CONST_API.channels.apps + CONST_API.routes.getDeferredRevenueActions,
			requestBody,
			config,
		)

		dispatch({
			type: REDUX_CONST.appConstants.getDeferredRevenueActions.success,
			payload: data,
		})
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message
		if (message === CONST_ERRORS['401ExpiredToken']) {
			dispatch(logout())
		}
		dispatch({
			type: REDUX_CONST.appConstants.getDeferredRevenueActions.fail,
			payload: message,
		})
	}
}
export const getCogsWithoutJobsActions = () => async (dispatch, getState) => {
	// console.log('Events:Request:GetEvents')
	try {
		dispatch({
			type: REDUX_CONST.appConstants.getCogsWithoutJobsActions.request,
		})

		const {
			userLogin: { userInfo },
		} = getState()

		const config = {
			headers: {
				Authorization: `Bearer ${userInfo.token}`,
				'Content-Type': 'application/json',
			},
		}

		// Prepare the body for the POST request
		const requestBody = {
			returnType: 'BUSINESS_MANAGER',
		}
		console.log(requestBody)

		const { data } = await axios.post(
			CONST_API.channels.apps + CONST_API.routes.getCogsWithoutJobsActions,
			requestBody,
			config,
		)

		console.log(data)

		dispatch({
			type: REDUX_CONST.appConstants.getCogsWithoutJobsActions.success,
			payload: data,
		})
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message
		if (message === CONST_ERRORS['401ExpiredToken']) {
			dispatch(logout())
		}
		dispatch({
			type: REDUX_CONST.appConstants.getCogsWithoutJobsActions.fail,
			payload: message,
		})
	}
}
export const createPotentialBackcharge =
	({
		jobId,
		email,
		displayName,
		estimator,
		tearOffCrew,
		installCrew,
		comment,
		materials,
		labor,
		total,
		responsibleContact,
	}) =>
	async (dispatch, getState) => {
		// console.log('Events:Request:GetEvents')
		try {
			dispatch({
				type: REDUX_CONST.appConstants.createPotentialBackcharge.request,
			})

			const {
				userLogin: { userInfo },
			} = getState()

			const config = {
				headers: {
					Authorization: `Bearer ${userInfo.token}`,
					'Content-Type': 'application/json',
				},
			}

			// Prepare the body for the POST request
			const requestBody = {
				jobId,
				email,
				displayName,
				estimator,
				tearOffCrew,
				installCrew,
				comment,
				materials,
				labor,
				total,
				responsibleContact,
			}
			console.log(requestBody)

			const { data } = await axios.post(
				CONST_API.channels.apps + CONST_API.routes.createPotentialBackcharge,
				requestBody,
				config,
			)

			dispatch({
				type: REDUX_CONST.appConstants.createPotentialBackcharge.success,
				payload: data,
			})
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			if (message === CONST_ERRORS['401ExpiredToken']) {
				dispatch(logout())
			}
			dispatch({
				type: REDUX_CONST.appConstants.createPotentialBackcharge.fail,
				payload: message,
			})
		}
	}
export const createJobSiteVisit =
	({
		jobId,
		salesRep,
		supervisor,
		supervisorEmail,
		tearOffCrew,
		installCrew,
		siteZip,
		categories,
	}) =>
	async (dispatch, getState) => {
		// console.log('Events:Request:GetEvents')
		try {
			dispatch({
				type: REDUX_CONST.appConstants.createJobSiteVisit.request,
			})

			const {
				userLogin: { userInfo },
			} = getState()

			const config = {
				headers: {
					Authorization: `Bearer ${userInfo.token}`,
					'Content-Type': 'application/json',
				},
			}

			// Prepare the body for the POST request
			const requestBody = {
				jobId,
				salesRep,
				supervisor,
				supervisorEmail,
				tearOffCrew,
				installCrew,
				siteZip,
				categories,
			}
			// console.log(requestBody)

			const { data } = await axios.post(
				CONST_API.channels.apps + CONST_API.routes.createJobSiteVisit,
				requestBody,
				config,
			)

			dispatch({
				type: REDUX_CONST.appConstants.createJobSiteVisit.success,
				payload: data,
			})
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			if (message === CONST_ERRORS['401ExpiredToken']) {
				dispatch(logout())
			}
			dispatch({
				type: REDUX_CONST.appConstants.createJobSiteVisit.fail,
				payload: message,
			})
		}
	}

export const createCustomerMessage =
	({ phoneNumber, message, user }) =>
	async (dispatch, getState) => {
		// console.log('Events:Request:GetEvents')
		try {
			dispatch({
				type: REDUX_CONST.appConstants.createCustomerMessage.request,
			})

			const {
				userLogin: { userInfo },
			} = getState()

			const config = {
				headers: {
					Authorization: `Bearer ${userInfo.token}`,
					'Content-Type': 'application/json',
				},
			}

			// Prepare the body for the POST request
			const requestBody = {
				phoneNumber,
				message,
				user,
			}
			// console.log(requestBody)

			const { data } = await axios.post(
				CONST_API.channels.apps + CONST_API.routes.createCustomerMessage,
				requestBody,
				config,
			)
			console.log(data)
			dispatch({
				type: REDUX_CONST.appConstants.createCustomerMessage.success,
				payload: data,
			})
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error?.response?.data?.errors[0]?.msg
						? error.response.data.errors[0].msg
						: error.message
			if (message === CONST_ERRORS['401ExpiredToken']) {
				dispatch(logout())
			}

			dispatch({
				type: REDUX_CONST.appConstants.createCustomerMessage.fail,
				payload: message,
			})
		}
	}
export const getCustomerConversation =
	({ cellPhoneNumber, homePhoneNumber }) =>
	async (dispatch, getState) => {
		// console.log('Events:Request:GetEvents')
		try {
			dispatch({
				type: REDUX_CONST.appConstants.getCustomerConversation.request,
			})

			const {
				userLogin: { userInfo },
			} = getState()

			const config = {
				headers: {
					Authorization: `Bearer ${userInfo.token}`,
					'Content-Type': 'application/json',
				},
			}

			// Prepare the body for the POST request
			const requestBody = {
				cellPhoneNumber,
				homePhoneNumber,
			}
			// console.log(requestBody)

			const { data } = await axios.post(
				CONST_API.channels.apps + CONST_API.routes.getCustomerConversation,
				requestBody,
				config,
			)

			dispatch({
				type: REDUX_CONST.appConstants.getCustomerConversation.success,
				payload: data,
			})
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			if (message === CONST_ERRORS['401ExpiredToken']) {
				dispatch(logout())
			}
			dispatch({
				type: REDUX_CONST.appConstants.getCustomerConversation.fail,
				payload: message,
			})
		}
	}

export const uploadExcelFile =
	({ file, updateChatSpace, sheetId, department }) =>
	async (dispatch, getState) => {
		const DEPARTMENTS = { commercial: 'commercial', finance: 'finance' }
		try {
			dispatch({
				type: REDUX_CONST.appConstants.uploadExcelFile.request,
			})
			const {
				userLogin: { userInfo },
			} = getState()

			const allowedEmails =
				department === DEPARTMENTS.commercial
					? [
							'justin@romanroofinginc.com',
							'nick@romanroofinginc.com',
							'joe@romanroofinginc.com',
							'lindsey@romanroofinginc.com',
						]
					: [
							'marissa@romanroofinginc.com',
							'justin@romanroofinginc.com',
							'robin@romanroofinginc.com',
							'ashley@romanroofinginc.com',
							'lindsey@romanroofinginc.com',
						]

			if (!allowedEmails.includes(userInfo.email)) {
				throw new Error('Not Authorized to upload files.')
			}

			// 🧠 PARSE EXCEL TO JSON
			const reader = new FileReader()
			reader.onload = async (e) => {
				const data = new Uint8Array(e.target.result)
				const workbook = XLSX.read(data, { type: 'array' })
				const sheetName = workbook.SheetNames[0]
				const worksheet = workbook.Sheets[sheetName]

				let normalizedData

				// 🧪 Special handling for Citizens Transactions
				if (
					sheetId === CONST_GOOGLE_SHEET_IDS.MX_UPLOAD_CITIZENS_TRANSACTIONS
				) {
					const sheetRows = XLSX.utils.sheet_to_json(worksheet, {
						header: 1,
						raw: false,
					})

					const headerRowIndex = sheetRows.findIndex(
						(row) =>
							row.includes('TRANS DATE') && row.includes('ORIGINAL GROSS AMT'),
					)

					if (headerRowIndex === -1)
						throw new Error('Could not find data header row.')

					const headers = sheetRows[headerRowIndex]
					const dataRows = sheetRows.slice(headerRowIndex + 1)

					normalizedData = dataRows.map((row) => {
						const obj = {}
						headers.forEach((key, i) => {
							obj[key] = row[i] ?? null
						})
						return obj
					})
				} else {
					// 🧠 Standard sheet parsing
					const allHeaders = XLSX.utils.sheet_to_json(worksheet, {
						header: 1,
					})[0]

					const rawRows = XLSX.utils.sheet_to_json(worksheet)
					normalizedData = rawRows.map((row) => {
						const fullRow = {}
						allHeaders.forEach((header) => {
							fullRow[header] = row.hasOwnProperty(header) ? row[header] : null
						})
						return fullRow
					})
				}

				const config = {
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${userInfo.token}`,
					},
				}

				//console.log('Sending file data to google.')
				const response = await axios.post(
					CONST_API.channels.apps + CONST_API.routes.uploadExcelFile,
					{ data: normalizedData, sheetId, updateChatSpace },
					config,
				)

				//console.log(response.data)
				dispatch({
					type: REDUX_CONST.appConstants.uploadExcelFile.success,
					payload: response.data,
				})
			}

			reader.readAsArrayBuffer(file)
		} catch (error) {
			console.log(error)
			dispatch({
				type: REDUX_CONST.appConstants.uploadExcelFile.fail,
				payload:
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
			})
		}
	}
